import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PortalComponent } from './portal.component';
import { PortalResolve } from './portal.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'zohooauth2callback',
        loadChildren: () => import('./integrations/integrations.module').then(m => m.IntegrationsModule)
      },
      {
        path: 'manage/veil-encoder',
        loadChildren: () => import('./veil-encoder/veil-encoder.module').then(m => m.VeilEncoderModule)
      },
      {
        path: 'manage/user-profile',
        loadChildren: () => import('./user/user-profile.module').then(m => m.UserProfileModule)
      },
      // {
      //   path: 'manage/advertiserSettings',
      //   loadChildren: () => import('./account-information/advertiser-settings/advertiser-settings.module').then(m => m.AdvertiserSettingsModule)
      // },
      {
        path: 'manage/paymentInformation',
        loadChildren: () => import('./account-info/payment-information/payment-information.module').then(m => m.PaymentInformationModule)
      },
      {
        path: 'manage/triggers',
        loadChildren: () => import('./triggers/triggers.module').then(m => m.TriggersModule)
      },
      {
        path: 'manage/trigger/view/:id',
        loadChildren: () => import('./trigger/trigger.module').then(m => m.TriggerModule)
      },
      {
        path: 'manage/trigger/create-bvs',
        loadChildren: () =>
          import('./trigger/create-edit-bvs-trigger/create-edit-bvs-trigger.module').then(
            m => m.CreateEditBvsTriggerModule
          )
      },
      {
        path: 'manage/trigger/create-acr',
        loadChildren: () =>
          import('./trigger/create-edit-acr-trigger/create-edit-acr-trigger.module').then(
            m => m.CreateEditAcrTriggerModule
          )
      },
      {
        path: 'manage/trigger/create-custom',
        loadChildren: () =>
          import('./trigger/create-edit-custom-trigger/create-edit-custom-trigger.module').then(
            m => m.CreateEditCustomTriggerModule
          )
      },
      {
        path: 'manage/trigger/create-vidvita-radio',
        loadChildren: () =>
          import('./trigger/create-edit-vidvita-radio-trigger/create-edit-vidvita-radio-trigger.module').then(
            m => m.CreateEditVidvitaRadioTriggerModule
          )
      },
      {
        path: 'manage/trigger/edit-bvs/:id',
        loadChildren: () =>
          import('./trigger/create-edit-bvs-trigger/create-edit-bvs-trigger.module').then(
            m => m.CreateEditBvsTriggerModule
          )
      },
      {
        path: 'manage/trigger/edit-acr/:id',
        loadChildren: () =>
          import('./trigger/create-edit-acr-trigger/create-edit-acr-trigger.module').then(
            m => m.CreateEditAcrTriggerModule
          )
      },
      {
        path: 'manage/trigger/edit-custom/:id',
        loadChildren: () =>
          import('./trigger/create-edit-custom-trigger/create-edit-custom-trigger.module').then(
            m => m.CreateEditCustomTriggerModule
          )
      },
      {
        path: 'manage/trigger/edit-vidvita-radio/:id',
        loadChildren: () =>
          import('./trigger/create-edit-vidvita-radio-trigger/create-edit-vidvita-radio-trigger.module').then(
            m => m.CreateEditVidvitaRadioTriggerModule
          )
      },
      {
        path: 'manage/tags/installation/:token',
        loadChildren: () => import('./tags/installation/installation.module').then(m => m.InstallationModule)
      },
      {
        path: 'manage/tags',
        loadChildren: () => import('./tags/tags.module').then(m => m.TagsModule)
      },
      {
        path: 'manage/support',
        loadChildren: () => import('./support/support.module').then(m => m.SupportModule)
      },
      {
        path: 'manage/integrations/snapchat',
        loadChildren: () => import('./integrations/integrations.module').then(m => m.IntegrationsModule)
      },
      {
        path: 'manage/integrations',
        loadChildren: () => import('./integrations/integrations.module').then(m => m.IntegrationsModule)
      },
      {
        path: 'manage/impersonate',
        loadChildren: () => import('./impersonate/impersonate.module').then(m => m.ImpersonateModule)
      },
      {
        //from the triggers
        path: 'manage/triggers/:triggerId/action/:id',
        loadChildren: () => import('./action/market/market.module').then(m => m.MarketModule)
      },
      {
        //from manage/actions
        path: 'manage/actions/:triggerId/:id',
        loadChildren: () => import('./action/market/market.module').then(m => m.MarketModule)
      },
      {
        //from the triggers
        path: 'manage/triggers/:triggerId/action/:id/radio-market',
        loadChildren: () => import('./action/radio-market/radio-market.module').then(m => m.RadioMarketModule)
      },
      {
        //from manage/actions
        path: 'manage/actions/:triggerId/:id/radio-market',
        loadChildren: () => import('./action/radio-market/radio-market.module').then(m => m.RadioMarketModule)
      },
      {
        path: 'manage/triggers/:triggerId/action/:id/bidding',
        loadChildren: () => import('./action/bidding/bidding.module').then(m => m.BiddingModule)
      },
      {
        path: 'manage/actions/:triggerId/:id/bidding',
        loadChildren: () => import('./action/bidding/bidding.module').then(m => m.BiddingModule)
      },
      {
        path: 'manage/triggers/:triggerId/action/:id/adwords',
        loadChildren: () => import('./action/adwords/adwords.module').then(m => m.AdwordsModule)
      },
      {
        path: 'manage/actions/:triggerId/:id/adwords',
        loadChildren: () => import('./action/adwords/adwords.module').then(m => m.AdwordsModule)
      },
      {
        path: 'manage/triggers/:triggerId/action/:id/fb-ads',
        loadChildren: () => import('./action/fb-ads/fb-ads.module').then(m => m.FbAdsModule)
      },
      {
        path: 'manage/actions/:triggerId/:id/fb-ads',
        loadChildren: () => import('./action/fb-ads/fb-ads.module').then(m => m.FbAdsModule)
      },
      {
        path: 'manage/triggers/:triggerId/action/:id/ttd',
        loadChildren: () => import('./action/trade-desk/trade-desk-ads.module').then(m => m.TradeDeskAdsModule)
      },
      {
        path: 'manage/actions/:triggerId/:id/ttd',
        loadChildren: () => import('./action/trade-desk/trade-desk-ads.module').then(m => m.TradeDeskAdsModule)
      },
      {
        path: 'manage/triggers/:triggerId/action/:id/snapchat',
        loadChildren: () => import('./action/snapchat/snapchat.module').then(m => m.SnapchatModule)
      },
      {
        path: 'manage/actions/:triggerId/:id/snapchat',
        loadChildren: () => import('./action/snapchat/snapchat.module').then(m => m.SnapchatModule)
      },
      {
        path: 'manage/triggers/:triggerId/action/:id/amazon',
        loadChildren: () => import('./action/amazon/amazon.module').then(m => m.AmazonModule)
      },
      {
        path: 'manage/actions/:triggerId/:id/amazon',
        loadChildren: () => import('./action/amazon/amazon.module').then(m => m.AmazonModule)
      },
      {
        path: 'manage/triggers/:triggerId/action/:id/bing',
        loadChildren: () => import('./action/bing/bing.module').then(m => m.BingModule)
      },
      {
        path: 'manage/actions/:triggerId/:id/bing',
        loadChildren: () => import('./action/bing/bing.module').then(m => m.BingModule)
      },
      {
        path: 'manage/triggers/:triggerId/action/:id/twitter',
        loadChildren: () => import('./action/twitter/twitter-ads.module').then(m => m.TwitterAdsModule)
      },
      {
        path: 'manage/actions/:triggerId/:id/twitter',
        loadChildren: () => import('./action/twitter/twitter-ads.module').then(m => m.TwitterAdsModule)
      },
      {
        // create action from trigger detail page
        path: 'manage/triggers/:triggerId/actions/create',
        loadChildren: () => import('./actions/create/create-action.module').then(m => m.CreateActionModule)
      },
      {
        // create action from actions list page
        path: 'manage/actions/create',
        loadChildren: () => import('./actions/create/create-action.module').then(m => m.CreateActionModule)
      },
      {
        // actions list page
        path: 'manage/actions',
        loadChildren: () => import('./actions/actions.module').then(m => m.ActionsModule)
      },
      {
        path: 'manage/reports',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'manage/scheduled-reports',
        loadChildren: () => import('./scheduled-reports/scheduled-reports.module').then(m => m.ScheduledReportsModule)
      },
      {
        path: 'manage/ad-codes',
        loadChildren: () => import('./ad-codes/ad-codes.module').then(m => m.AdCodesModule)
      },
      {
        path: 'manage/looker/:lookerDashboardName',
        loadChildren: () => import('./looker-embed/looker-embed.module').then(m => m.LookerEmbedModule)
      },
      {
        path: 'manage/agency-settings',
        loadChildren: () => import('./agency-settings/agency-settings.module').then(m => m.AgencySettingsModule)
      },
      {
        path: 'manage/advertiser-settings',
        loadChildren: () =>
          import('./advertiser-settings/advertiser-settings.module').then(m => m.AdvertiserSettingsModule)
      },
      {
        path: 'manage/admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'manage/goals',
        loadChildren: () => import('./goals/goals.module').then(m => m.GoalsModule)
      },
      {
        path: 'manage/goals/create',
        loadChildren: () => import('./goals/create/create.module').then(m => m.CreateGoalModule)
      },
      {
        path: 'manage/trigger/create-weather',
        loadChildren: () =>
          import('./trigger/create-edit-weather-trigger/create-edit-weather-trigger.module').then(
            m => m.CreateEditWeatherTriggerModule
          )
      },
      {
        path: 'manage/trigger/edit-weather/:id',
        loadChildren: () =>
          import('./trigger/create-edit-weather-trigger/create-edit-weather-trigger.module').then(
            m => m.CreateEditWeatherTriggerModule
          )
      },
      {
        path: 'manage/trigger/weather/edit-priority',
        loadChildren: () =>
          import('./trigger/create-edit-weather-trigger/edit-priority/edit-priority.module').then(
            m => m.EditPriorityModule
          )
      },
      {
        path: 'manage/trigger/create-nlp',
        loadChildren: () =>
          import('./trigger/create-edit-nlp-trigger/create-edit-nlp-trigger.module').then(
            m => m.CreateEditNlpTriggerModule
          )
      },
      {
        path: 'manage/trigger/edit-nlp/:id',
        loadChildren: () =>
          import('./trigger/create-edit-nlp-trigger/create-edit-nlp-trigger.module').then(
            m => m.CreateEditNlpTriggerModule
          )
      },
      {
        path: 'manage/onboarding',
        loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule)
      },
      {
        path: 'manage/onboarding/triggers',
        loadChildren: () => import('./onboarding/triggers/triggers.module').then(m => m.OnboardingTriggersModule)
      },
      {
        path: 'manage/dashboard',
        loadChildren: () =>
          import('./reporting-dashboard/reporting-dashboard.module').then(m => m.ReportingDashboardModule)
      },
      {
        path: 'manage/alerts',
        loadChildren: () => import('./alerts-dashboard/alerts-dashboard.module').then(m => m.AlertsDashboardModule)
      },
      {
        path: 'manage/team-members',
        loadChildren: () => import('./account-info/team-members/team-members.module').then(m => m.TeamMembersModule)
      },
      {
        path: 'manage/team-members/create-member',
        loadChildren: () => import('./account-info/team-members/create-team-member/create-team-member.module').then(
            e => e.CreateTeamMemberModule)
      },
      {
        path: 'manage/team-members/edit-member/:id',
        loadChildren: () => import('./account-info/team-members/edit-team-member/edit-team-member.module').then(
            e => e.EditTeamMemberModule)
      },
      {
        path: 'manage/brand-settings',
        loadChildren: () => import('./account-info/brand-settings/brand-settings.module').then(m => m.BrandSettingsModule)
      },
      {
        path: 'manage/brand-settings/change-card',
        loadChildren: () => import('./account-info/brand-settings/change-card/change-card.module').then(
            e => e.ChangeCardModule)
      },
      {
        path: 'manage/brand-settings/manage-plan',
        loadChildren: () => import('./account-info/brand-settings/manage-plan/manage-plan.module').then(
            e => e.ManagePlanModule)
      },
      {
        path: 'manage/brand-settings/change-name',
        loadChildren: () => import('./account-info/brand-settings/change-name/change-name.module').then(
            e => e.ChangeNameModule)
      },
      {
        path: 'manage/brand-settings/create-member',
        loadChildren: () => import('./account-info/team-members/create-team-member/create-team-member.module').then(
            e => e.CreateTeamMemberModule)
      },
      {
        path: 'manage/brand-settings/edit-member/:id',
        loadChildren: () => import('./account-info/team-members/edit-team-member/edit-team-member.module').then(
            e => e.EditTeamMemberModule)
      },
      {
        path: 'manage/postlogs',
        loadChildren: () => import('./postlogs/postlogs.module').then(m => m.PostlogsModule)
      },
      {
        path: 'manage/lead-sources',
        loadChildren: () => import('./lead-sources/lead-sources.module').then(m => m.LeadSourcesModule)
      },
      {
        path: 'manage/trigger/create-kinetiq-acr',
        loadChildren: () => import('./trigger/create-edit-kinetiq-acr-trigger/create-edit-kinetiq-acr-trigger.module').then(m => m.CreateEditKinetiqAcrTriggerModule)
      },
      {
        path: 'manage/trigger/edit-kinetiq-acr/:id',
        loadChildren: () => import('./trigger/create-edit-kinetiq-acr-trigger/create-edit-kinetiq-acr-trigger.module').then(m => m.CreateEditKinetiqAcrTriggerModule)
      },
      {
        path: 'manage/market-group-settings',
        loadChildren: () => import('./market-group-settings/market-group-settings.module').then(m => m.MarketGroupSettingsModule)
      },
      {
        path: 'manage/change-management',
        loadChildren: () => import('./change-management/change-management.module').then(m => m.ChangeManagementModule)
      },
      {
        path: 'manage',
        component: PortalComponent,
        resolve: {
          portal: PortalResolve
        },
        children: []
      }
    ])
  ],
  exports: [RouterModule]
})
export class PortalRoutingModule {}
